<template>
  <div>
    <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
      <el-form-item label="套餐系列：">
        <el-input v-model.trim="searchForm.name" placeholder="支持模糊搜索" clearable></el-input>
      </el-form-item>
      <el-form-item label="套餐类型：">
        <el-select v-model="searchForm.isVoice" clearable>
          <el-option v-for="item in isVoiceOption" :value="item.code" :key="item.description"
            :label="item.description"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="余额限制：">
        <el-select v-model="searchForm.type" clearable>
          <el-option label="不限制" value="0"></el-option>
          <el-option label="限制余额" value="1"></el-option>
          <el-option label="限制余额并且开户预存" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" plain icon="el-icon-search" @click="getPkgGroupListPageHandle">搜索</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="showAddPkgGroup">新建系列</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%"
      :header-cell-style="{ background: '#f5f5f5' }">
      <el-table-column prop="name" label="系列名称" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="typeName" label="余额限制" align="center" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="isNextMonthName" label="跨月类型" align="center" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="saleName" label="活动名称" align="center"></el-table-column>
      <el-table-column prop="yucunName" label="二次活动" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="limitName" label="限速设置" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="stateName" label="状态" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center" width="520">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="titleOpen(scope.row)">弹窗配置</el-button>
          <el-button type="text" size="small" @click="pagePkgGroup(scope.row)">页面配置</el-button>
          <el-button type="text" size="small" @click="sharePkgGroup(scope.row)">商城配置</el-button>
          <el-button type="text" size="small" @click="sharePkgGroup1(scope.row)">优惠卷活动</el-button>
          <el-button type="text" size="small" @click="selectPkg(scope.row)">套餐活动</el-button>
          <el-button type="text" size="small" @click="yuDataOpen(scope.row)">续费配置</el-button>
          <el-button type="text" size="small" @click="sharePkgGroup11(scope.row)">商户号</el-button>

          <el-dropdown style="margin-left: 10px;">
            <el-button type="text">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="autoChangeGroup(scope.row)" style="color:#409EFF;">转移系列</el-dropdown-item>
              <el-dropdown-item @click.native="changeStateHandle(scope.row.id)" style="color:red"> {{
                showbtnText(scope.row.state) }}</el-dropdown-item>
              <el-dropdown-item @click.native="deleteGroupId(scope.row.id)" style="color:red">删除系列</el-dropdown-item>
              <!-- <el-dropdown-item  @click.native="autoChangeGroup(scope.row)">添加实例</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
      layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
    </el-pagination>
    <el-dialog :append-to-body="true" :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel"
      :close-on-click-modal="false">
      <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">
        <el-form-item label="套餐系列名称：" prop="name">
          <el-input v-model.trim="addOrEditGroupForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="余额限制：" prop="type">
          <el-select v-model="addOrEditGroupForm.type" placeholder="请选择">
            <el-option v-for="item in isPriceOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余额购买参数：" prop="priceData">
          <el-input v-model.trim="addOrEditGroupForm.priceData" placeholder="严谨按照参数规范填写 参数示列请点击下方按钮" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否跨月：" prop="isNextMonth">
          <el-select v-model="addOrEditGroupForm.isNextMonth" placeholder="请选择">
            <el-option v-for="item in isMonthOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="活动类型：" prop="isPrice">
          <el-select v-model="addOrEditGroupForm.isSale" placeholder="请选择">
            <el-option v-for="item in isPriceOptions" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二次活动：" prop="yucun">
          <el-select v-model="addOrEditGroupForm.yucun" placeholder="请选择">
            <el-option v-for="item in isYucunOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="秒反设置：" prop="isMiao">
          <el-select v-model="addOrEditGroupForm.isMiao" placeholder="请选择">
            <el-option v-for="item in isMiaoList" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="addOrEditGroupForm.isMiao == 1" label="秒反金额/元：" prop="miaoPrice">
          <el-input v-model.trim="addOrEditGroupForm.miaoPrice" placeholder="请输入你要秒反得金额" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="套餐类型：" prop="isNextMonth">
          <el-select v-model="addOrEditGroupForm.isVoice" placeholder="请选择">
            <el-option v-for="item in isVoiceOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="实名跳转：" prop="poolName">
          <el-input v-model.trim="addOrEditGroupForm.poolName" placeholder="控制实名跳转，电信卡请填 电信 ，联通卡 填联通。特殊实名链接 请直接填链接"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="微信弹窗内容：" prop="remark">
          <el-input v-model.trim="addOrEditGroupForm.remark" placeholder="将会在微信套餐页面进行弹窗提示" clearable></el-input>
        </el-form-item>


        <el-form-item label="实名限制：" prop="isAuth">
          <el-radio-group v-model="addOrEditGroupForm.isAuth">
            <el-radio :label="1">无限制</el-radio>
            <el-radio :label="0">先套餐后实名</el-radio>
            <el-radio :label="2">先实名后套餐</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="限速规则：">
          <el-select v-model="addOrEditGroupForm.limitId" clearable filterable>
            <el-option v-for="item in branchSupplierOption" :value="item.code" :key="item.code"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="阶梯虚量：">
          <el-select v-model="addOrEditGroupForm.xuliangId" clearable filterable>
            <el-option v-for="item in branchSupplierOptions" :value="item.code" :key="item.code"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客服链接：" prop="kefuUrl">
          <el-input v-model.trim="addOrEditGroupForm.kefuUrl" clearable></el-input>
        </el-form-item>
        <el-form-item label="提前停机天数：" prop="stopDay">
          <el-input v-model.trim="addOrEditGroupForm.stopDay" placeholder="在套餐有效期低于设置的天数时，将进行停机操作（选填）。"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="流量提前停机：" prop="stopData">
          <el-input v-model.trim="addOrEditGroupForm.stopData" placeholder="当套餐剩余流量小于设置数时（单位/M），进行停机"
            clearable></el-input>
        </el-form-item>

           <el-form-item label="日限额：" prop="dayLimitData">
          <el-input v-model.trim="addOrEditGroupForm.dayLimitData" placeholder="当日真实使用多少GB时，进行停机。次日恢复"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="限制次月个数：" prop="limitNextPkg">
          <el-input v-model.trim="addOrEditGroupForm.limitNextPkg" placeholder="限制充值次月套餐的个数（仅限基础包）（选填）。"
            clearable></el-input>
        </el-form-item>
        
        <el-form-item label="首充设备页面：" prop="isShowTui">
          <el-radio-group v-model="addOrEditGroupForm.isShowTui">
            <el-radio :label="1">进入直购年包设备页面</el-radio>
            <el-radio :label="0">进入正常页面</el-radio>
          </el-radio-group>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="showYue">查询余额参数示列</el-button>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="addOrEidtGroupHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" title="余额参数示列" :visible.sync="shareImgs" width="700px" @close="cancel1"
      :close-on-click-modal="false">
      <div style="text-align: center; padding: 10px 0; color: #f56c6c">
        注：最多只支持6个参数，amount代表充值金额/元
        giftBalance表示赠送金额/元。请修改后完整输入此参数
      </div>
      <div style="text-align: center; width: 100%">
        <p alt="" style="margin: 0 auto">{{ urls }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制参数</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="商品图(建议像素512*512)：">
          <input type="file" ref="file1" placeholder="必选" />
          <img :src="getImgUrl() + shareForm.shareImg" alt="" width="150" height="150" />
        </el-form-item>

        <el-form-item label="商品标题:" prop="shareName">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareName" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品分类:" prop="shareType">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareType" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商品价格/元:" prop="sharePrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.sharePrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="分代理商佣金/元:" prop="shareYongjing">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareYongjing" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="上下架状态：" prop="isShare">
          <el-radio-group v-model="shareForm.isShare">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类排序:" prop="shareTypeOrderBy">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareTypeOrderBy" placeholder="排序（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品排序:" prop="shareShopOrderBY">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareShopOrderBY" placeholder="排序（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup11" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="商户类型：" prop="subType">
          <el-radio-group v-model="shareForm.subType">
            <el-radio label="20">微信支付</el-radio>
            <el-radio label="50">乐刷支付</el-radio>
            <el-radio label="30">财富通</el-radio>
            <el-radio label="60">汇付支付</el-radio>
            <el-radio label="80">斗洪支付</el-radio>
            <el-radio label="61">火脸支付</el-radio>
            <el-radio label="62">易支付</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="微信商户号:" prop="subId" v-if="shareForm.subType == 20">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subId" placeholder="商户号须和公众号进行绑定" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="微信商户密钥:" prop="subKey" v-if="shareForm.subType == 20">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subKey" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="乐刷商户编号:" prop="subId" v-if="shareForm.subType == 50">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subId" placeholder="乐刷商户号" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="乐刷支付密钥:" prop="subKey" v-if="shareForm.subType == 50">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subKey" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="乐刷回调密钥:" prop="subLeShuaIds" v-if="shareForm.subType == 50">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subLeShuaIds" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商户编号:" prop="subId" v-if="shareForm.subType == 30">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subId" placeholder="开发管理-商户编号" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="通道编码:" prop="subKey" v-if="shareForm.subType == 30">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subKey" placeholder="开发管理-通道编码" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商户MD5秘钥:" prop="subLeShuaIds" v-if="shareForm.subType == 30">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subLeShuaIds" placeholder="开发管理-MD5密钥" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="应用ID:" prop="subId" v-if="shareForm.subType == 60">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subId" placeholder="app_开头信息" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="应用密钥:" prop="subKey" v-if="shareForm.subType == 60">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subKey" placeholder="api_live_开头信息" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商户编号:" prop="subId" v-if="shareForm.subType == 80">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subId" placeholder="斗洪商户号  一般以666开头的商户号" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="斗洪公钥:" prop="subKey" v-if="shareForm.subType == 80">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subKey" placeholder="斗洪公钥" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="APPID-编码:" prop="subLeShuaIds" v-if="shareForm.subType == 80">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subLeShuaIds" placeholder="公众号appid和产品编码（问上游要）中间用-隔开" clearable></el-input>
          </el-col>
        </el-form-item>


        <el-form-item label="商户编号:" prop="subId" v-if="shareForm.subType == 61">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subId" placeholder="商户号" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="操作者账号:" prop="subKey" v-if="shareForm.subType == 61">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subKey" placeholder="操作者账号" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="授权码-salt:" prop="subLeShuaIds" v-if="shareForm.subType == 61">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subLeShuaIds" placeholder="授权码-salt" clearable></el-input>
          </el-col>
        </el-form-item>


        <el-form-item label="商户编号:" prop="subId" v-if="shareForm.subType == 62">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subId" placeholder="商户号" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商户密钥:" prop="subKey" v-if="shareForm.subType == 62">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subKey" placeholder="商户密钥" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="支付域名:" prop="subLeShuaIds" v-if="shareForm.subType == 62">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subLeShuaIds" placeholder="支付域名" clearable></el-input>
          </el-col>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle11">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup1" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="活动图(建议像素750*1392)：">
          <input type="file" ref="file2" placeholder="必选">
          <img :src="getImgUrl() + shareForm.priceImgUrl" alt="" width="150" height="150">
        </el-form-item>
        <el-form-item label="购买券价格:" prop="salePrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.salePrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="券面值/元:" prop="saleQuanPrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.saleQuanPrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="券个数:" prop="saleQuanSize">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.saleQuanSize" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="次券面值/元:" prop="saleQuanPriceTwos">
          <el-col :span="22">
            <el-input v-model="shareForm.saleQuanPriceTwos" placeholder="选填-可赠送不同面额的券" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="次券个数:" prop="saleQuanSizeTwos">
          <el-col :span="22">
            <el-input v-model="shareForm.saleQuanSizeTwos" placeholder="选填-可赠送不同面额的券" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="卷过期时间:" prop="saleDay">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.saleDay" placeholder="必选-多少天后过期" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="赠送套餐:" prop="salePkgId">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.salePkgId" placeholder="选填- 请填入要赠送的套餐编码。（套餐详情查询编码）" clearable></el-input>
          </el-col>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle1">确 定</el-button>
      </div>
    </el-dialog>



    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="yueDataFlg" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="yueData" :model="yueData" label-width="120px">
        <p style="color:red">仅仅支持自运营流量池的卡。套餐使用完后或者过期后 可用余额自动购买绑定的套餐</p>
        <el-form-item label="续费类型：" prop="subType">
          <el-radio-group v-model="yueData.sysType">
            <el-radio label="0">套餐超套配置</el-radio>
            <el-radio label="1">套餐续期配置</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="套餐编码:" prop="yuPkgDataId" v-if="yueData.sysType == 0">
          <el-col :span="22">
            <el-input v-model.trim="yueData.yuPkgDataId" placeholder="不填则不自动续费" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="续费类型：" prop="yuType" v-if="yueData.sysType == 1">
          <el-radio-group v-model="yueData.yuType">
            <el-radio :label="0">暂不配置过期续费</el-radio>
            <el-radio :label="1">自动续延订购的最大主套餐</el-radio>
            <el-radio :label="2">自定义续延套餐编码</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="套餐编码:" prop="yuPkgOutId" v-if="yueData.sysType == 1 && yueData.yuType == 2">
          <el-col :span="22">
            <el-input v-model.trim="yueData.yuPkgOutId" placeholder="套餐到期前4天，自动使用余额订购此套餐" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="sureYuDataMthed()">确 定</el-button>
      </div>
    </el-dialog>





    <el-dialog :append-to-body="true" class="formDialog" title="自动迁移系列" :visible.sync="changeFlg" width="600px"
      @close="changeCancel" :close-on-click-modal="false">
      <el-form ref="changeData" :model="changeData" label-width="120px">
        <p style="color:red">此配置是卡激活多少天后，自动迁移套餐系列。 一般用于前期低价套餐 自动 转移高价套餐系列</p>
        <el-form-item label="新系列名称：">
          <el-select v-model="changeData.changeId" clearable filterable>
            <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="激活天数:" prop="changeDay">
          <el-col>
            <el-input v-model.trim="changeData.changeDay" placeholder="当大于0时，才会自动生效" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeCancel">取 消</el-button>
        <el-button type="primary" @click="changeSure()">确 定</el-button>
      </div>
    </el-dialog>







    <el-dialog :append-to-body="true" class="formDialog" title="页面配置" :visible.sync="isShowPage" width="600px"
      @close="pageCancel" :close-on-click-modal="false">
      <el-form ref="pageData" :model="pageData" label-width="120px">
        <el-form-item label="活动页面：" prop="isNewPage">
          <el-radio-group v-model="pageData.isNewPage">
            <el-radio :label="0">经典充值页面</el-radio>
            <el-radio :label="1">简洁大气页面</el-radio>
          </el-radio-group>
        </el-form-item>
        <p style="color:red">选填：不填则系统默认购卡宣传图和跳转链接</p>
        <el-form-item label="活动图(像素644*200)：" v-if="pageData.isNewPage == 1">
          <input type="file" ref="file3" placeholder="">
          <img :src="getImgUrl() + pageData.newHomePcImg" alt="" width="300" height="100">
        </el-form-item>

        <el-form-item label="点击跳转链接:" prop="newHomeUrl" v-if="pageData.isNewPage == 1">
          <el-col :span="22">
            <el-input v-model.trim="pageData.newHomeUrl" placeholder="填 购卡 即可跳转购卡页面，其它填第三方跳转链接" clearable></el-input>
          </el-col>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pageCancel">取 消</el-button>
        <el-button type="primary" @click="sureToPage">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog :append-to-body="true" class="formDialog" title="套餐活动设置" :visible.sync="isShowPkg" width="600px"
      @close="pkgCancel" :close-on-click-modal="false">
      <el-form ref="pkgData" :model="pkgData" label-width="120px">
        <el-form-item label="活动页面：" prop="isShow">
          <el-radio-group v-model="pkgData.isShow">
            <el-radio :label="0">关闭套餐活动</el-radio>
            <el-radio :label="1">开启套餐活动</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动图(建议像素750*1392)：">
          <input type="file" ref="file4" placeholder="">
          <img :src="getImgUrl() + pkgData.showImg" alt="" width="300" height="600">
        </el-form-item>

        <el-form-item label="套餐ID:" prop="showPkgId">
          <el-col :span="22">
            <el-input v-model.trim="pkgData.showPkgId" placeholder="购买套餐ID，套餐详情中查询套餐编码" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="预存金额:" prop="showYu">
          <el-col :span="22">
            <el-input v-model.trim="pkgData.showYu" placeholder="单位/元。填了会直接预存+购买套餐，不填则直接购买套餐，" clearable></el-input>
          </el-col>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pkgCancel">取 消</el-button>
        <el-button type="primary" @click="sureToPkg">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog :append-to-body="true" class="formDialog" title="弹窗" :visible.sync="titleFlg" width="600px"
      @close="titleFlg = false" :close-on-click-modal="false">
      <el-form ref="titleData" :model="titleData" label-width="120px">
        <el-form-item label="状态：" prop="titleState">
          <el-radio-group v-model="titleData.titleState">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="弹窗内容:" prop="titleRemark">
          <el-col :span="22">
            <el-input v-model.trim="titleData.titleRemark" placeholder="" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="跳转链接:" prop="titleUrl">
          <el-col :span="22">
            <el-input v-model.trim="titleData.titleUrl" placeholder="选填" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="类型：" prop="titleType">
          <el-radio-group v-model="titleData.titleType">
            <el-radio :label="0">未实名弹</el-radio>
            <el-radio :label="1">已实名弹</el-radio>
            <el-radio :label="2">有套餐弹</el-radio>
            <el-radio :label="3">有余额弹</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="titleFlg = false">取 消</el-button>
        <el-button type="primary" @click="sureTitle">确 定</el-button>
      </div>
    </el-dialog>




  </div>
</template>
<script>
import {
  getPkgGroupListPage,
  addPkgGroup,
  updatePkgGroup,
  changePkgGroupState,
  getPkgIsMonthOption,
} from "@/api/package.js";
import common from "@/utils/common.js";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      changeFlg: false,
      changeData: {
        id: '',
        changeId: '',
        changeDay: ''
      },
      pkgGroup: [],



      yueDataFlg: false,
      yueData: {
        sysType: '0', //0表示套餐用完设置  1 表示过期设置
        id: '',
        yuType: '',
        yuPkgDataId: '',
        yuPkgOutId: ''
      },
      existBackImg: false,
      shareGroup: false,
      existBackImg1: false,
      shareGroup1: false,
      shareGroup11: false,
      shareForm: {
        id: "",
        name: "",
        subId: "",
        subKey: "",
        subLeShuaIds: '',
        subType: '',


        shareType: '',
        shareYongjing: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',

        shareName: "",
        shareImg: "",
        priceImgUrl: "",
        isShare: "",


        salePrice: '',
        saleQuanPrice: '',
        saleQuanSize: '',
        saleQuanPriceTwos: "",
        saleQuanSizeTwos: "",
        saleDay: '',
        salePkgId: ''
      },
      branchSupplierOption: [],
      branchSupplierOptions: [],
      isShareOptions: [
        {
          code: 0,
          description: "禁用",
        },
        {
          code: 1,
          description: "启用",
        },
      ],
      urls: "",
      shareImgs: false,
      searchForm: {
        name: "",
        isVoice: "",
        isNextMonth: "",
      },
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      isPriceOptions: [
        {
          code: 0,
          description: "无活动",
        },
        {
          code: 1,
          description: "购买优惠券活动",
        }

      ],
      isMiaoList: [
        {
          code: 0,
          description: "不秒反",
        },
        {
          code: 1,
          description: "一次性秒反",
        },
      ],
      addOrEditGroupForm: {
        isShowTui:'',
        name: "",
        type: "",
        isMiao: "",
        yucun: "0",
        subId: "",
        subKey: "",
        miaoPrice: "",
        kefuUrl: "",
        priceImgUrl: "",
        isSale: "",
        isAuth: "",
        isNextMonth: "0",
        limitId: "",
        isShowApp: "",
        supplierType: "1",
        remark: "",
        isDown: "0",
        priceData: "",
        poolName: "",
        isVoice: "0",
        xuliangId: "",
        shareType: '',
        shareYongjing: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',
        stopDay: '',
        limitNextPkg: '',
        stopData: '',
        dayLimitData:'',


      },
      isPriceOption: [
        {
          code: 0,
          description: "不限制",
        },
        {
          code: 1,
          description: "限制余额",
        },
        {
          code: 3,
          description: "开户预存",
        },
        {
          code: 2,
          description: "限制余额并且开户预存",
        },
      ],
      isVoiceOption: [
        {
          code: 0,
          description: "流量",
        },
        {
          code: 1,
          description: "流量+语音",
        },
      ],

      isYucunOption: [
        {
          code: 0,
          description: "无二次活动",
        },
        {
          code: 1,
          description: "预存送免金券-29元券",
        },
        {
          code: 3,
          description: "购买叠加券活动",
        },
      ],
      currentId: "",
      addFlag: null,
      addGroupVisibale: false,
      title: "",
      pkgTypeOption: [],
      supplierOption: [],
      isMonthOption: [],
      addOrEditGroupRules: {
        name: [{ required: true, message: "请输入套餐名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择套餐名称", trigger: "change" },
        ],
        isNextMonth: [
          { required: true, message: "请选择套餐名称", trigger: "change" },
        ],
        supplierType: [
          { required: true, message: "请选择套餐名称", trigger: "change" },
        ],
      },


      pageData: {
        id: '',
        newHomeUrl: '',
        newHomePcImg: '',
        isNewPage: ''
      },
      isShowPage: false,



      pkgData: {
        id: '',
        isShow: '',
        showImg: '',
        showPkgId: '',
        showYu: ''
      },
      isShowPkg: false,

      titleFlg: false,
      titleData: {
        id: '',
        titleState: '',
        titleUrl: '',
        titleType: '',
        titleRemark: '',
      },


    };
  },
  methods: {
    titleOpen(row) {
      this.titleData.id = row.id;
      this.titleData.titleRemark = row.titleRemark;
      this.titleData.titleType = row.titleType;
      this.titleData.titleUrl = row.titleUrl;
      this.titleData.titleState = row.titleState;
      this.titleFlg = true;
    },
    sureTitle() {
      common.sysRequest("pkg/group/update/title", this.titleData, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            this.titleFlg = false;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },

    selectPkg(row) {
      this.pkgData.id = row.id;
      this.pkgData.showPkgId = row.showPkgId;
      this.pkgData.showImg = row.showImg;
      this.pkgData.isShow = row.isShow;
      this.pkgData.showYu = row.showYu;
      this.isShowPkg = true;
    },
    pkgCancel() {
      this.isShowPkg = false;
    },
    sureToPkg() {
      let fd = new FormData();
      Object.keys(this.pkgData).forEach((key) => {
        fd.append(key, this.pkgData[key]);
      });
      fd.append("imgUrl", this.$refs.file4.files[0]);
      common.sysRequest("pkg/group/show/pkg", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file4.value = "";
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.isShowPkg = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },





    pageCancel() {
      this.isShowPage = false;
    },
    pagePkgGroup(row) {
      this.pageData.id = row.id;
      this.pageData.newHomePcImg = row.newHomeImg;
      this.pageData.newHomeUrl = row.newHomeUrl;
      this.pageData.isNewPage = row.isNewPage;
      this.isShowPage = true;
    },
    sureToPage() {
      let fd = new FormData();

      Object.keys(this.pageData).forEach((key) => {
        fd.append(key, this.pageData[key]);
      });
      if (this.pageData.isNewPage == 1) {
        fd.append("pageUrl", this.$refs.file3.files[0]);
      }
      common
        .sysRequest("pkg/group/page/type", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            if (this.pageData.isNewPage == 1) {
              this.$refs.file3.value = "";
            }
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.isShowPage = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }



    },


    deleteGroupId(id) {

      this.$confirm("此操作会把套餐系列和系列下面的套餐全部删除。确定要操作吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        var data = { id: id }
        common.sysRequest("pkg/group/delete/group", data, "post").then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
          .catch((err) => console.error(err));

      })

    },
    autoChangeGroup(row) {
      common.getPkgGroupListCom(this, 'pkgGroup');
      this.changeData.changeDay = row.changeDay;
      this.changeData.id = row.id;
      this.changeData.changeId = row.changeId
      this.changeFlg = true;
    },
    changeCancel() {
      this.changeFlg = false;
    },
    changeSure() {
      common
        .sysRequest("pkg/group/auto/changeGroup", this.changeData, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            this.changeFlg = false;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },

    sureYuDataMthed() {
      common
        .sysRequest("pkg/group/update/yue/config", this.yueData, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            this.yueDataFlg = false;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    yuDataOpen(row) {
      this.yueData.id = row.id;
      this.yueData.yuPkgDataId = row.yuPkgDataId;
      this.yueData.yuPkgOutId = row.yuPkgOutId;
      this.yueData.yuType = row.yuType;
      this.yueDataFlg = true;
    },


    sharePkgGroup11(row) {
      this.shareForm.id = row.id;
      this.shareForm.subId = row.subId;
      this.shareForm.subKey = row.subKey;
      this.shareForm.salePkgId = row.salePkgId;

      this.shareForm.subType = row.subType;
      this.shareForm.subLeShuaIds = row.subLeShuaIds;
      this.shareForm.shareName = row.shareName;

      this.shareGroup11 = true;
    },

    sharePkgGroup(row) {
      this.shareForm.id = row.id;
      this.shareForm.shareName = row.shareName;
      this.shareForm.shareImg = row.shareImg;
      this.shareForm.isShare = row.isShare;
      this.shareForm.shareType = row.shareType;
      this.shareForm.sharePrice = row.sharePrice;
      this.shareForm.shareYongjing = row.shareYongjing;
      this.shareForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.shareForm.shareShopOrderBY = row.shareShopOrderBY;
      this.existBackImg = true;
      this.shareGroup = true;
    },

    sharePkgGroup1(row) {
      this.shareForm.id = row.id;
      this.shareForm.shareName = row.shareName;
      this.shareForm.priceImgUrl = row.priceImgUrl;
      this.shareForm.salePrice = row.salePrice;
      this.shareForm.saleQuanPrice = row.saleQuanPrice;
      this.shareForm.saleQuanSize = row.saleQuanSize;
      this.shareForm.saleQuanPriceTwos = row.saleQuanPriceTwo;
      this.shareForm.saleQuanSizeTwos = row.saleQuanSizeTwo;
      this.shareForm.saleDay = row.saleDay;
      this.shareForm.salePkgId = row.salePkgId;
      this.existBackImg1 = true;
      this.shareGroup1 = true;
    },
    cancel12() {
      this.yueDataFlg = false;
      this.shareGroup = false;
      this.existBackImg1 = false;
      this.shareGroup1 = false;
      this.shareGroup11 = false;
      this.$refs.shareForm.resetFields();
    },
    addOrEidtPkgHandle() {
      let fd = new FormData();
      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file1.files[0]);

      common
        .sysRequest("pkg/group/insert/share", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file1.value = "";
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },
    addOrEidtPkgHandle1() {
      let fd = new FormData();

      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file2.files[0]);

      common
        .sysRequest("pkg/group/insert/price/img", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file2.value = "";
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup1 = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },

    addOrEidtPkgHandle11() {
      var data = {
        id: this.shareForm.id,
        subId: this.shareForm.subId,
        subKey: this.shareForm.subKey,
        subType: this.shareForm.subType,
        subLeShuaIds: this.shareForm.subLeShuaIds,
      };
      common
        .sysRequest("pkg/group/insert/wx/config", data, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.shareGroup11 = false;
            this.getPkgGroupListPageHandle();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    //复制功能
    copy() {
      var clipboard = new Clipboard(".copy_url");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        this.shareImgs = false;
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.success("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    showYue() {
      this.urls =
        '[{"amount":25,"giftBalance":0},{"amount":35,"giftBalance":0.5},{"amount":50,"giftBalance":1},{"amount":100,"giftBalance":2},{"amount":200,"giftBalance":5},{"amount":500,"giftBalance":20}]';
      this.shareImgs = true;
    },
    cancel() {
      this.shareImgs = false;
      this.addGroupVisibale = false;
      this.$refs.addOrEditGroupForm.resetFields();
    },
    cancel1() {
      this.shareImgs = false;
    },
    showbtnText(state) {
      return common.showTxtByState(state, { 0: "启用", 1: "禁用" });
    },
    getPkgGroupListPageHandle($event) {
      common.resetCurrentPage(this, $event, "tbpg");
      var data = common.getRequestParams(this, "tbpg", this.searchForm);
      getPkgGroupListPage(data).then((res) => {
        common.listCallback(this, res, "tbpg");
      });
    },
    showAddPkgGroup() {
      this.addGroupVisibale = true;
      this.addFlag = true;
      this.title = "新增套餐系列";
      this.addOrEditGroupForm = this.$data.addOrEditGroupForm;
    },
    showEditPkgGroup(row) {
      this.addGroupVisibale = true;
      this.addFlag = false;
      this.title = "修改套餐系列";
      this.addOrEditGroupForm.isShowTui = row.isShowTui;
      this.addOrEditGroupForm.stopData = row.stopData;
      this.addOrEditGroupForm.isShowApp = row.isShowApp;
      this.addOrEditGroupForm.changeDay = row.changeDay;
      this.addOrEditGroupForm.changeId = row.changeId;
      this.addOrEditGroupForm.limitNextPkg = row.limitNextPkg;
      this.addOrEditGroupForm.dayLimitData = row.dayLimitData;
      this.addOrEditGroupForm.shareType = row.shareType;
      this.addOrEditGroupForm.shareYongjing = row.shareYongjing;
      this.addOrEditGroupForm.sharePrice = row.sharePrice;
      this.addOrEditGroupForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.addOrEditGroupForm.shareShopOrderBY = row.shareShopOrderBY;
      this.addOrEditGroupForm.yucun = row.yucun;
      this.addOrEditGroupForm.limitId = row.limitId;
      this.addOrEditGroupForm.xuliangId = row.xuliangId;
      this.addOrEditGroupForm.isAuth = row.isAuth;
      this.addOrEditGroupForm.kefuUrl = row.kefuUrl;
      this.addOrEditGroupForm.priceImgUrl = row.priceImgUrl;
      this.addOrEditGroupForm.name = row.name;
      this.addOrEditGroupForm.type = row.type;
      this.addOrEditGroupForm.isVoice = row.isVoice;
      this.addOrEditGroupForm.isSale = row.isSale;
      this.addOrEditGroupForm.isNextMonth = row.isNextMonth;
      this.addOrEditGroupForm.supplierType = row.supplierType;
      this.addOrEditGroupForm.remark = row.remark;
      this.addOrEditGroupForm.poolName = row.poolName;
      this.addOrEditGroupForm.priceData = row.priceData;
      this.currentId = row.id;
      this.xuliangId = row.xuliangId;
      this.addOrEditGroupForm.isDown = row.isDown;
      this.addOrEditGroupForm.isMiao = row.isMiao;
      this.addOrEditGroupForm.miaoPrice = row.miaoPrice;
      this.addOrEditGroupForm.stopDay = row.stopDay;
    },
    addOrEidtGroupHandle() {
      this.$refs.addOrEditGroupForm.validate((valid) => {
        if (valid) {
          var data = this.addOrEditGroupForm;
          if (this.addFlag == true) {
            addPkgGroup(data).then((res) => callback(res));
          } else {
            data.id = this.currentId;
            updatePkgGroup(data).then((res) => callback(res));
          }
        }
        var _this = this;
        function callback(res) {
          if (res.data.code == 200) {
            _this.getPkgGroupListPageHandle();
            _this.addGroupVisibale = false;
          } else {
            _this.$message.error(res.data.message);
          }
        }
      });
    },
    changeStateHandle(id) {
      var data = {
        id,
      };
      changePkgGroupState(data).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.getPkgGroupListPageHandle();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getPkgGroupListPageHandle();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val;
      this.getPkgGroupListPageHandle();
    },
  },
  created() {
    this.getPkgGroupListPageHandle();
    common.getPkgTypeOptionCom(this, "pkgTypeOption");
    common.getSupplierOptionCom(this, "supplierOption");
    common.getSupplierLimitOptionCom(this, 'branchSupplierOption')
    common.getSupplierLimitOptionComs(this, 'branchSupplierOptions')
    getPkgIsMonthOption().then((res) => {
      if (res.data.code == 200) {
        this.isMonthOption = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    });
  },
};
</script>
<style></style>
